import moment from "moment";

export default class OrderItem {
  static getTypeSpecificData(order) {
    let typeSpecificData;
    switch (order.type) {
      case "MC":
        typeSpecificData = {
          description: order.description,
          doseForm: order.doseForm,
          dosage: order.dosage,
          dosingParameters: order.dosingParameters,
          emergencyDrugPack: order.emergencyDrugPack,
          frequency: order.frequency,
          compound: order.compound,
          opioid: order.opioid,
          name: order.name,
          route: order.route,
          strength: order.strength,
          symptoms: order.symptoms,
          type: order.type,
          gpi: order.gpi,
          administered: order.administered,
          additionalInstructions: order.additionalInstructions
            ? order.additionalInstructions
            : null,
          prescribedSchedule: order.prescribedSchedule,
          prescribedTimes: order.prescribedTimes,
          prescribedFrequency: order.prescribedFrequency,
          prescribedDays: order.prescribedDays,
          reviewed: order.reviewed,
        };
        if (order.compound) {
          typeSpecificData.ingredients = order.ingredients;
        }
        break;
      case "TM":
        typeSpecificData = {
          treatmentType: order.treatmentType,
        };
        break;
      case "EQ":
        typeSpecificData = {
          dmeType: order.dmeType,
        };
        break;
      case "SP":
        typeSpecificData = {
          supplyType: order.supplyType,
        };
        break;
      case "DG":
        let newDiagnosis = [];
        if (order.diagnosisType === "PM" || order.diagnosisType === "SC") {
          newDiagnosis.push(order.diagnosisObject);
        } else if (order.diagnosisType === "RL") {
          for (let relatedDiagnosis of order.relatedDiagnoses) {
            newDiagnosis.push(relatedDiagnosis.diagnosisObject);
          }
        }
        typeSpecificData = {
          diagnosisType: order.diagnosisType,
          newDiagnosis: newDiagnosis,
          physician: order.physician ? { id: order.physician.id } : null,
        };
        break;
      case "LC":
        let facility = null;
        if (order.facility && Object.keys(order.facility).length > 0)
          facility = { id: order.facility.id };
        typeSpecificData = {
          levelOfCare: order.levelOfCare,
          levelOfCareType: order.levelOfCareType,
          facility: facility,
          reasonsForGip: order.reasonsForGip || [],
          symptoms: order.symptoms || [],
        };
        break;
      case "VF":
        typeSpecificData = {
          role: order.role,
          otherRole: order.otherRole,
          visits: order.visits,
          timeInterval: order.timeInterval,
          prnVisits: order.prnVisits,
          reason: order.reason,
        };
        break;
      case "OT":
        typeSpecificData = {
          name: order.name,
        };
        break;
      case "RC":
        typeSpecificData = {
          recertificationFor: order.recertificationFor,
          certifyingPhysician: order.certifyingPhysician,
          attendingPhysician: order.attendingPhysician,
        };
        break;
      default:
        break;
    }
    if (order.orderTypeId) typeSpecificData.id = order.orderTypeId;
    return typeSpecificData;
  }

  static convertToServerFormat(date: string) {
    if (date != "") {
      return moment(date, "YYYY-MM-DD").utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
    } else {
      return date;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/order-item.ts